<div class="w-full flex flex-col gap-5">
  <ng-container *ngFor="let blockArray of blocks | keyvalue">
    <ng-container *ngFor="let block of blockArray.value; let i = index">
      <ng-container [ngSwitch]="block.variant">
        <!-- TEXT VARIANT -->
        <ng-container *ngSwitchCase="'text'">
          <div
            [ngClass]="[
              'flex',
              block.class || '',
              block.props?.orientation === 'horizontal' ? 'flex-row' : 'flex-col',
              'gap-' + (block.props?.gap || 2),
            ]">
            <div *ngFor="let textBlock of block.props?.blocks">
              <p [ngClass]="['text-xl font-bold', textBlock.class || '']">
                {{ textBlock.content | translate }}
              </p>
            </div>
          </div>
        </ng-container>

        <!-- BUTTON VARIANT -->
        <ng-container *ngSwitchCase="'button'">
          <p-button
            type="button"
            fluid
            [ngClass]="block.class"
            [label]="block.props?.label | translate"
            [severity]="block.props?.severity"
            [loading]="block.props?.loading | async"
            [disabled]="block.props?.disabled | async"
            (onClick)="block.props?.onClick()">
            <i *ngIf="block.props?.icon" [ngClass]="[block.props?.icon, 'mr-2']"></i>
          </p-button>
        </ng-container>

        <!-- TEXTAREA VARIANT -->
        <ng-container *ngSwitchCase="'input_textarea'">
          <label for="" class="block text-sm font-medium">{{ block.props?.label | translate }}</label>
          <textarea
            pTextarea
            style="resize: none"
            [ngClass]="block.class"
            [class.w-full]="true"
            [placeholder]="block.props?.placeholder | translate"
            [rows]="block.props?.rows"
            [ngModel]="block.props?.['value'] | async"
            (ngModelChange)="block.props?.['onChange']($event)"></textarea>
          <p class="text-sm text-red-500" *ngIf="block.props?.error | async">{{ block.props?.error | async }}</p>
        </ng-container>

        <!-- INPUT FILE VARIANT -->
        <ng-container *ngSwitchCase="'input_file'">
          <label for="" class="block text-sm font-medium">{{ block.props?.label | translate }}</label>
          <p-fileUpload
            [class.w-full]="true"
            [mode]="'basic'"
            [accept]="block.props?.accept || '.pdf,.doc,.docx,.txt'"
            (onSelect)="block.props?.['onSelect']($event)"
            (onRemove)="block.props?.['onRemove']($event)"></p-fileUpload>
        </ng-container>

        <!-- Comment Block -->
        <ng-container *ngSwitchCase="'comment'">
          <sm-comment-block
            [label]="block.props?.label"
            [comment]="block.props?.content"
            [date]="block.props?.date"
            [class]="block.class"></sm-comment-block>
        </ng-container>

        <!-- Dropdown List Block -->
        <ng-container *ngSwitchCase="'dropdown_list'">
          <div class="w-full" [ngClass]="block.class">
            <!-- Label / Toggle -->
            <button
              class="flex items-center justify-between w-full text-left text-lg font-semibold"
              (click)="toggleDropdown(blockArray.key + '_' + i)">
              {{ block.props?.label | translate }}

              <span class="text-sm">
                {{ dropdownOpen[blockArray.key + '_' + i] ? '▲' : '▼' }}
              </span>
            </button>

            <!-- Items -->
            <ul class="ml-4 mt-2 list-disc" *ngIf="dropdownOpen[blockArray.key + '_' + i]">
              <li
                *ngFor="let item of block.props?.items; let dri = index"
                role="button"
                tabindex="0"
                (click)="block.props?.onClick?.(item, dri)"
                (keydown.enter)="block.props?.onClick?.(item, dri)"
                (keydown.space)="block.props?.onClick?.(item, dri)"
                class="cursor-pointer select-none">
                <ng-container *ngIf="block.props?.renderAs(item, dri) as r">
                  <ng-container *ngIf="r.type === 'TEXT'">
                    {{ r.value }}
                  </ng-container>

                  <ng-container *ngIf="r.type === 'LINK'">
                    <a class="underline cursor-pointer" target="_blank" [ngClass]="r.class">
                      {{ r.value }}
                    </a>
                  </ng-container>
                </ng-container>
              </li>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'seperator'">
          <hr />
        </ng-container>

        <!-- Custom Component Block -->
        <ng-container *ngSwitchCase="'custom'">
          <ng-container *ngComponentOutlet="block.props?.component; inputs: block.props?.inputs" />
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
